import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=42654246&scoped=true"
import script from "./tag.vue?vue&type=script&setup=true&lang=js"
export * from "./tag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=42654246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42654246",
  null
  
)

export default component.exports